import { LoadableAfterPaint } from '@confluence/loadable';

export const ContentHeaderPresenceLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentHeaderPresence" */ '../src/presence/ContentHeaderPresence.tsx'
			)
		).ContentHeaderPresence,
});
